<template>
  <div>
    <slot v-if="isDefinedRoute"> </slot>
    <router-view v-if="!isDefinedRoute" />
  </div>
</template>
<script>
export default {
  props: {
    routeName: {
      type: String,
      required: true
    }
  },
  computed: {
    isDefinedRoute() {
      const { $route, routeName } = this;
      return $route.name == routeName;
    }
  }
};
</script>
